export default "__VITE_ASSET__CSs8Larm__"